export default __webpack_public_path__ + "static/media/product_7.b8b9dd06.webp";